import api from 'api';

interface Params {
  asPath: string;
  headers: { [key: string]: string };
}

const getCoursesPageData = async ({ asPath, headers }: Params) => {
  try {
    const urlParts = asPath.split('/');
    const courseSlug = urlParts[3];
    const courseAdminPage = urlParts[4];

    const courses = await api.get(
      `/admin/courses?slug=${courseSlug}&adminPage=${
        courseAdminPage ? courseAdminPage : 'summary'
      }`,
      { headers }
    );

    return courses.data.courses[0];
  } catch (error) {
    return null;
  }
};

export default getCoursesPageData;
